import { Typography, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import format from 'date-fns/format';
import React from 'react';

interface PastPaymentsProps {
  successfulTransactions: any[];
}
const PastPayments: React.FC<PastPaymentsProps> = ({
  successfulTransactions,
}) => {
  const theme = useTheme();
  if (!successfulTransactions?.length) {
    return <Typography>No records found</Typography>;
  }
  return (
    <Box sx={{ mt: 1 }}>
      {successfulTransactions?.map((transaction, index) => {
        const plan = transaction?.subscription?.subscriptionPlan;
        return (
          <>
            <Box sx={{ my: 1 }}>
              <Typography
                variant='subtitle2'
                color={theme.ragyaPalette.gray4}
                fontWeight={400}
              >
                {transaction?.rzpOrderId || transaction?.rzpSubscriptionId} .{' '}
                {format(new Date(transaction?.createdAt), 'MMM dd, yyyy')}
              </Typography>
              <Typography
                variant='subtitle1'
                color={theme.ragyaPalette.gray3}
                fontWeight={500}
              >
                {plan?.name}
              </Typography>
              <Typography
                variant='subtitle2'
                color={theme.ragyaPalette.gray4}
                fontWeight={400}
              >{`${plan?.currencySymbol}${plan?.price} (including 18% GST)`}</Typography>
            </Box>
            {index < successfulTransactions.length - 1 && <Divider />}
          </>
        );
      })}
    </Box>
  );
};

export default PastPayments;
